export class ApiClientError extends Error {
  constructor(message: string, public status: number) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: init?.body ? { "content-type": "application/json", ...init.headers } : init?.headers,
  });
  const payload = await response.json().catch(() => ({ error: "応答を読み取れませんでした" })) as { error?: string };
  if (!response.ok) throw new ApiClientError(payload.error || "処理に失敗しました", response.status);
  return payload as T;
}

export interface ProfileData {
  user: { id: string; name: string; email: string };
  profile: {
    displayName: string; bio: string; ageGroup: string; gender: string; region: string; occupation: string;
    targetingOptOut: boolean; profilePublic: boolean; completed: boolean; interestTags: string[]; avatarDataUrl: string | null;
  };
}

export interface Question {
  id: string;
  author: { id: string | null; name: string; avatarDataUrl: string | null };
  body: string;
  imageUrl: string | null;
  axis: string;
  analysisEnabled: boolean;
  options: Array<{ label: string }>;
  tags: string[];
  targetSummary: string[];
  answered: boolean;
  createdAt: number;
}

export interface RevealData {
  question: Question;
  reveal: {
    total: number;
    counts: number[];
    perspectives: Array<{ id: string; option_index: number; reason: string; reasonTags: string[]; confidence: number; created_at: number; reconsidered: boolean; saved: boolean }>;
    myAnswer: { optionIndex: number; reason: string; reasonTags: string[]; confidence: number; createdAt: number; revision: null | { optionIndex: number; note: string; confidence: number; createdAt: number } };
    attributeBreakdown: Record<string, Array<{ value: string; total: number; counts: number[] }>>;
    privacyNote: string;
  };
}

export interface AnalysisData {
  axes: Array<{ key: string; left: string; right: string; count: number; value: number | null; status: string }>;
  tags: Array<{ tag: string; count: number; value: number | null }>;
  answerCount: number;
  method: string;
}

export interface ActivityData {
  summary: {
    delivered: number;
    answered: number;
    changes: number;
    saved: number;
    analysisAnswerCount: number;
    readyAxes: number;
  };
  delivered: Question[];
  answered: Array<{
    question: Question;
    answer: { optionIndex: number; optionLabel: string; reason: string; createdAt: number };
  }>;
  changes: Array<{
    id: string;
    questionId: string;
    questionBody: string;
    tags: string[];
    fromLabel: string;
    toLabel: string;
    note: string;
    createdAt: number;
  }>;
  savedPerspectives: Array<{
    id: string;
    questionId: string;
    questionBody: string;
    optionLabel: string;
    reason: string;
    reconsidered: boolean;
    savedAt: number;
  }>;
  privacyNote: string;
}
